import { createFileRoute } from "@tanstack/react-router";
import { LegacyBrRedirect } from "@/site/components/birthday-request/legacy-br-redirect";

/** Legacy `/bd7/<member magic_link>` — a tracked variant of `/bday/<magic>` (web.py:1379). */
export const Route = createFileRoute("/bd7/$magic")({
  component: () => <LegacyBrRedirect />,
});
